"use client";

// diagnostics-auto-flush-client.tsx
// Tiny mount-only client component. When the user has opted into sharing
// diagnostics (shareDiagnostics=true), it arms the clog auto-flusher so the
// client periodically POSTs its log buffer to /api/diagnostics (also on errors
// and page-hide). Renders nothing. Gated server-side by DiagnosticsAutoFlush.

import { useEffect } from "react";
import { initDiagnosticsAutoFlush } from "@/lib/client-log";

export default function DiagnosticsAutoFlushClient({ enabled }: { enabled: boolean }) {
  useEffect(() => {
    initDiagnosticsAutoFlush(enabled);
  }, [enabled]);
  return null;
}
